enum LoginMode {
  Login,
  ChangePassword,
  ForgotPassword,
  SelectOrganization,
}

export default LoginMode;
